import { render } from "./LayoutWrapper.vue?vue&type=template&id=db05b048"
import script from "./LayoutWrapper.vue?vue&type=script&lang=js"
export * from "./LayoutWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__